import React from "react";
import { useLocation } from "react-router-dom";
import Pagination from "../../comman/Pagination";
import { fDate, fDateUTC } from "../../utils/helper/timeHelpers";

const FinancialDetails = () => {
  const { state } = useLocation();
  const payout = state?.payout;

  const formatTime = (isoString) => {
    const date = new Date(isoString);

    let hours = date.getHours();
    let minutes = date.getMinutes();

    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${minutes} ${ampm}`;
  };

  return (
    <>
      <section className="content mb-5">
        <div className="container-fluid">
          <div className="row titlepad">
            <div className="col-md-12">
              <div className="mt-3 mb-3">
                <div className="dashbed-border-bottom"></div>
              </div>
              <div className="row">
                <div className="col-sm-8">
                  {/* <p className="page-sub-head">Financial Details</p> */}
                </div>
                <div className="col-md-4 text-sm-right mt-3">
                  <a
                    href="javascript:history.back()"
                    className="btn-md py-2 px-3 btn-primary"
                  >
                    <i className="fa fa-print"></i>
                    Print
                  </a>
                  <a
                    href="javascript:history.back()"
                    className="btn-md px-3 py-2 btn-secondary"
                  >
                    <i className="fa fa-chevron-circle-left"></i> Back
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Invoice Details */}
          <div className="row">
            <div className="col-md-12">
              <div id="accordion" className="accordion accordion-app">
                <div className="card mb-0">
                  <div
                    className="card-header"
                    data-toggle="collapse"
                    href="#agreement"
                  >
                    <a href="#" className="card-title text-black">
                      Financial Details{" "}
                    </a>
                    <span className="badge badge-warning ml-2 mt-2">
                      {payout?.status}
                    </span>
                  </div>

                  <div
                    id="agreement1"
                    className="card-body collapse show"
                    data-parent="#accordion"
                  >
                    <div className="loa-detail-labelw">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="mb-0">Order No</label>
                            <p className="mt-0">{payout?.orderNo}</p>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="mb-0">Date</label>
                            <p className="mt-0">
                              <td>{fDateUTC(payout?.createdAt, null,  'DD MMM, YYYY')}</td>
                            </p>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="mb-0">Time</label>
                            <p className="mt-0">{formatTime(payout?.createdAt)}</p>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="mb-0">Payment Status</label>
                            <p className="mt-0 text-danger">{payout?.status}</p>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="mb-0">Staff Name</label>
                            <p className="mt-0">{payout?.vendorName}</p>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="mb-0">Service Type</label>
                            <p className="mt-0">{payout?.serviceName}</p>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="mb-0">Amount</label>
                            <p className="mt-0">{payout?.amount}</p>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="mb-0">Customer Name</label>
                            <p className="mt-0">
                              {payout?.customerName} {payout?.customerPhone}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FinancialDetails;
